//const API_URL = "http://localhost/backend_ptp_admin/";
const API_URL = "https://ptp.gkp.pk/backend_ptp_admin/";
export const requestGetAll = async (url) =>{
    const response = await fetch(API_URL + url);
    return await response.json();
} 

export const requestGetOne = async (url) => {
    const response = await fetch(API_URL + url);
    return await response.json();
}